import $ from 'jquery'

class BreakingNews {
    constructor(element) {
        this._div = element;
        this._jsonUrl = "";
        this._ribbon = "";
        this.getData();
        this.clearData();
        this.init();
    }

    getData() {
        this._jsonUrl = $(this._div).data("url");
        this._ribbon = $(this._div).data("ribbon");
    }

    clearData() {
        $(this._div).removeAttr("data-url");
        $(this._div).removeAttr("data-ribbon");
    }

    init() {
        let _this = this;
        $.get(
            this._jsonUrl, {}, function (data) {
                if (data && data.length > 0) {
                    $(data).each(function () {
                        let _currentRibbon = _this._ribbon.replace("@URL@",this.url);
                        _currentRibbon = _currentRibbon.replace("@TITLE@",this.title);
                        $(_this._div).append(_currentRibbon);
                    });
                }
            }, 'json'
        );
    }
}

export default BreakingNews;